import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/authentication.service';
import { RoleService } from '../services/role.service';
import { User } from '../interfaces/user';
import { StorageService } from '../services/storage.service';

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<any> {

    constructor(
        private authService: AuthService,
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<void> | Observable<User> | Promise<User> | User {
        if (this.authService && this.authService.getUserSession().information.document) {
            return this.authService.getUserSession();
        } else {
            if (StorageService.checkStorage().getItem('_email') && this.authService) {
                return this.authService.getFullUserByEmail(StorageService.checkStorage().getItem('_email')).pipe(
                    catchError(() => of(null))
                );
            } else if (sessionStorage.getItem('_email') && this.authService) {
                return this.authService.getFullUserByEmail(sessionStorage.getItem('_email')).pipe(
                    catchError(() => of(null))
                );
            } else if (StorageService.checkStorage().getItem('_phone') && this.authService) {
                return this.authService.getFullUserByPhone(StorageService.checkStorage().getItem('_phone'));
            } else if (sessionStorage.getItem('_phone') && this.authService) {
                return this.authService.getFullUserByPhone(sessionStorage.getItem('_phone'));
            } else {
                return null;
            }
        }
    }

}
